export default __webpack_public_path__ + "static/2423-83a06e3966dbd6caedd888800c140ef7.gif";